/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, cssMap, jsx } from '@compiled/react';

import ThemeableImage from '@atlaskit/image';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	margin: {
		marginBlock: token('space.400'),
	},
	imageRoundedBorder: {
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('border.radius.300'),
	},
	imageRoundedNoBorder: {
		borderRadius: token('border.radius.300'),
	},
});

const imageStyles = css({
	width: '100%',
	minWidth: '0',
	[media.above.md]: {
		width: '125%',
	},
});

type ImageProps = {
	src: string;
	srcDark: string;
	caption: string;
	alt: string;
	borderAppearance: 'rounded-border' | 'rounded-no-border' | 'none';
	hasMargin?: boolean;
};

export const Image = ({
	src,
	srcDark,
	caption,
	alt,
	borderAppearance = 'none',
	hasMargin = true,
}: ImageProps) => {
	return (
		<Stack xcss={hasMargin && styles.margin} space="space.100" alignInline="center">
			<ThemeableImage
				src={src}
				srcDark={srcDark}
				css={[
					imageStyles,
					borderAppearance === 'rounded-border' && styles.imageRoundedBorder,
					borderAppearance === 'rounded-no-border' && styles.imageRoundedNoBorder,
				]}
				alt={alt}
			/>
			<Text color="color.text.subtlest">{caption}</Text>
		</Stack>
	);
};
